import React from "react";
import { Modal, Button, Select, Input, Checkbox, Row, Col, Typography } from "antd";
import moment from "moment";
import async from "async";
import { store } from "../NextApp";

import Customers from "./addInsurance/customers";
import Coverages from "./addInsurance/coverages";
import Vehicles from "./addInsurance/vehicles";
import Dates from "./addInsurance/dates";
import Price from "./addInsurance/price";
import PaymentMethod from "./addInsurance/paymentMethod";

import ConfirmVin from "./addInsurance/confirmVin";
import purchase from "./addInsurance/purchase";
import errors from "./addInsurance/errors";
import save from "./addInsurance/save";

import AddClient from "../routes/data/clients/add";
import saveDraft from "./addInsurance/saveDraft";
import { disconnect } from "./terminal";
import { firestore } from "../firebase/firebase";
import { Switch } from "antd-new";

class Add extends React.PureComponent {
	state = {
		loading: false,
		loadingDraft: false,
		terminal: false,
		payingWithTerminal: false,
		coverages: [],
		availableAgents: [],
		isPolicyPaid: false,
		policyPaidId: "",
		partial_payment: false,
		partial_payment_sw: false,
		epay: false,
		extraCoverage: false,
	};

	getStoreProps() {
		const storeState = store.getState();
		const coverages = [];
		Object.entries(storeState.coverage?.contactList || {}).forEach(([index, element]) => {
			coverages.push({
				id: index,
				name: element.name,
				type: element.type,
				price: element.price,
				profit: element.profit,
				notes: element.notes,
				days: element.days,
				sr22: element.sr22 ? element.sr22 : false,
				pipe: element.pipe ? element.pipe : false,
				vehicles: element.vehicles,
			});
		});
		return {
			auth: storeState.auth,
			clients: storeState.clients.contactList,
			coverages,
		};
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ loading: false });
		Modal.error({
			title: "Looks like there something went wrong",
			content: error + " " + errorInfo + " Logs:" + JSON.stringify({ ...this.state, coverages: null }),
		});
	}

	verify = e => {
		e.preventDefault();
		this.setState({ loading: true });
		const parent = this;
		errors(this.state, { ...this.props, ...this.getStoreProps() })
			.then(paymentMethodId => {
				Modal.confirm({
					title: "Are you sure you want to create this insurance?",
					content: <ConfirmVin vin={this.state.vin} />,
					onOk() {
						return parent.purchase(paymentMethodId);
					},
				});
			})
			.catch(e => {
				this.setState({ loading: false });
				return Modal.error(e);
			});
	};

	purchase = async paymentMethodId => {
		//console.log(this.state)
		this.loadingHandler(true);
		const mergedProps = { ...this.props, ...this.getStoreProps() };
		purchase(this.state, mergedProps, paymentMethodId)
			.then(res => {
				save(res.receipt, res.charge, res.method, res.methodSource, this.state, mergedProps)
					.then(() => {
						this.loadingHandler(false);
						this.props.onContactClose();
					})
					.catch(e => {
						this.setState({ loading: false });
						this.loadingHandler(false);
						return Modal.error(e);
					});
			})
			.catch(e => {
				this.loadingHandler(false);
				return Modal.error(e);
			});
	};

	loadingHandler = load => {
		if (this.state.terminal) {
			this.setState({ payingWithTerminal: load });
		} else {
			this.setState({ loading: load });
		}
	};

	saveAsDraft = () => {
		this.setState({ loadingDraft: true });
		saveDraft(this.state, { ...this.props, ...this.getStoreProps() }).then(() => {
			this.setState({ loadingDraft: false });
			this.props.onContactClose();
		});
	};

	onSaveClient = (id, data) => {
		const auth = store.getState().auth;
		let collection;
		if (auth.type !== "capturist") {
			if (auth.type.endsWith("Admin")) {
				collection = "clients";
			} else {
				collection = "agents/" + auth.agent + "/clients";
			}
		} else {
			collection = "capturists/" + auth.uid + "/clients";
		}
		firestore.collection(collection).add({
			...data,
			timestamp: moment().toDate(),
		});
	};

	onClientClose = () => {
		this.setState({
			addClient: false,
		});
	};

	componentDidMount() {
		const auth = store.getState().auth;
		if (auth.type === "capturist") {
			this.getAgents();
		}
		if (auth.type === "Agent") {
			const agentRef = firestore.doc("agents/" + auth.uid);
			agentRef.get().then(e => {
				this.setState({ partial_payment: e.data().partial_payment, epay: !!e.data().epay });
			});
		}
		//console.log(this.props.auth);
		//console.log(this.state);
	}
	async getMyAgents() {
		const auth = store.getState().auth;
		if (auth.type === "capturist") {
			const agentRef = firestore.doc("capturists/" + auth.uid);
			const agentData = await agentRef.get();
			return agentData.data().selectedAgents;
		}
	}
	async getAgents() {
		const myAgents = await this.getMyAgents();
		return firestore
			.collection("agents")
			.orderBy("name", "asc")
			.get()
			.then(agent => {
				const allAgents = [];
				return async.eachOfSeries(
					agent.docs,
					(agent, key, callback) => {
						if (myAgents.includes(agent.id)) {
							allAgents.push({
								key: agent.id,
								agentName: agent.data().name,
							});
						}

						callback();
					},

					() => {
						this.setState({ availableAgents: allAgents });
					}
				);
			});
	}
	render() {
		const { open } = this.props;
		const { Option } = Select;
		const { auth, coverages, clients } = this.getStoreProps();
		return (
			<React.Fragment>
				<Modal
					title={"Add Insurance"}
					toggle={this.props.onContactClose}
					visible={open}
					confirmLoading={this.state.loading}
					closable={false}
					onCancel={this.props.onContactClose}
					footer={null}>
					<form onSubmit={this.verify}>
						<Customers auth={auth} route={"car insurance"} state={this.state} type={this.props.type} onChange={e => this.setState(e)} />
						{auth.type === "capturist" && (
							<div className="gx-form-group">
								<Select
									value={this.state.selectedAgent}
									style={{ width: "100%" }}
									placeholder="Select Agent*"
									onChange={e => {
										this.setState({ selectedAgent: e });
									}}
									required>
									{this.state.availableAgents?.map(item => (
										<Option value={item.key} key={item.key}>
											{item.agentName}
										</Option>
									))}
								</Select>
							</div>
						)}
						<Coverages coverages={coverages} clients={clients} type={this.props.type} state={this.state} onChange={e => this.setState(e)} />
						<Vehicles state={this.state} type={this.props.type} onChange={e => this.setState(e)} />
						{this.props.type === "truck" && (
							<Row style={{ marginBottom: 16 }}>
								<Col span={24}>
									<Checkbox
										checked={this.state.extraCoverage}
										onChange={e => {
											const checked = e.target.checked;
											this.setState({ extraCoverage: checked }, () => {
												// Recalculate total with doubled price
												const { coverageDays, coveragePrice, coverageProfit, dateRange, partial_payment_sw } = this.state;
												let total = 0;
												const multiplier = checked ? 2 : 1;
												if (coverageDays > 0 && this.state.coverage) {
													total = (partial_payment_sw ? coverageProfit : coveragePrice) * multiplier;
												} else if (dateRange && this.state.coverage) {
													const diff = dateRange[1].diff(dateRange[0], "days", true);
													total = (partial_payment_sw ? Math.ceil(diff) * coverageProfit : Math.ceil(diff) * coveragePrice) * multiplier;
												}
												if (this.state.coverage) {
													this.setState({ total });
												}
											});
										}}>
										<strong>Add Extra Coverage</strong> — Motor Truck Cargo Coverage ($1,000,000 limit / $2,500 deductible)
									</Checkbox>
								</Col>
							</Row>
						)}
						<Dates state={this.state} onChange={e => this.setState(e)} partial_payment_sw={this.state.partial_payment_sw} />
						<Price route={"car insurance"} state={this.state} />
						{auth.type === "capturist" && (
							<Row>
								<Col span={24}>
									<Typography.Title level={4}>Is Policy Paid</Typography.Title>
								</Col>

								<Col span={12}>
									<Checkbox
										onChange={value => {
											this.setState({
												isPolicyPaid: value.target.checked,
											});
										}}
									/>
									{this.state.isPolicyPaid && (
										<Input
											placeholder={"Policy Paid Id"}
											onChange={e => this.setState({ policyPaidId: e.target.value })}
											value={this.state.policyPaidId}
										/>
									)}
								</Col>
							</Row>
						)}

						<PaymentMethod
							state={this.state}
							props={this.props}
							epayEnabled={this.state.epay} /* nuevo */
							onTransactionSuccess={this.purchase} /* genera póliza cuando ePay ok */
						/>
						<div className={"gx-form-group"} style={{ textAlign: "right", marginTop: 20, marginBottom: -20 }}>
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<div>
									<Button onClick={this.saveAsDraft} type={"default"} loading={this.state.loading} disabled={this.state.loadingDraft}>
										Save as Draft
									</Button>
								</div>
								<div>
									<Button
										type={"danger"}
										onClick={() => {
											if (this.state.payingWithTerminal) {
												this.setState({ payingWithTerminal: false });
												return disconnect();
											} else {
												this.props.onContactClose();
											}
										}}>
										Cancel
									</Button>
									<>
										
										{!this.state.epay && (
											<Button
												htmlType={"submit"}
												onClick={() => this.setState({ terminal: false })}
												type={"primary"}
												loading={this.state.loading}
												disabled={this.state.loading}>
												Submit
											</Button>
										)}
									</>
								</div>
							</div>
						</div>
					</form>
				</Modal>
				<AddClient
					open={this.state.addClient}
					onSaveContact={this.onSaveClient}
					onContactClose={this.onClientClose}
					contact={{
						thumb: "",
						type: "",
						phone: "",
						name: "",
						email: "",
						rfc: "",
						dob: null,
						address: "",
						city: "",
						state: "",
						zip: "",
						country: "",
						notes: "",
					}}
				/>
			</React.Fragment>
		);
	}
}

export default Add;
